class MfaInputValidator{
    constructor(formId) {
        this.formId = formId;
    }
    enableMFAFormValidation(){
        Inputmask("", {
            "numericInput": true
        }).mask(".two-fa-input");
        var form = document.getElementById(this.formId);
        return FormValidation.formValidation(
                form,
                {
                    fields: {
                        'code_1': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                integer: {
                                    message: 'Value must be a number',
                                },
                            }
                        },
                        'code_2': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                integer: {
                                    message: 'Value must be a number',
                                },
                            }
                        },
                        'code_3': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                integer: {
                                    message: 'Value must be a number',
                                },
                            }
                        },
                        'code_4': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                integer: {
                                    message: 'Value must be a number',
                                },
                            }
                        },
                        'code_5': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                integer: {
                                    message: 'Value must be a number',
                                },
                            }
                        },
                        'code_6': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                integer: {
                                    message: 'Value must be a number',
                                },
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton()
                    }
                }
            );
    }
}

window.MfaInputValidator = MfaInputValidator;